/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Faq_Cloudflare_DetailInputs */

const en_marketing_faq_cloudflare_detail = /** @type {(inputs: Marketing_Faq_Cloudflare_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not to build. Local dev simulates D1, R2, Queues, Durable Objects, crons, and workflows. You need an account when you deploy, and the free tier goes a long way.`)
};

const es_marketing_faq_cloudflare_detail = /** @type {(inputs: Marketing_Faq_Cloudflare_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No para desarrollar. El entorno local simula D1, R2, Queues, Durable Objects, crons y flujos de trabajo. Necesitas una cuenta al desplegar, y el plan gratuito da mucho de sí.`)
};

const fr_marketing_faq_cloudflare_detail = /** @type {(inputs: Marketing_Faq_Cloudflare_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas pour développer. L'environnement local simule D1, R2, Queues, Durable Objects, crons et workflows. Un compte devient nécessaire au déploiement, et l'offre gratuite va loin.`)
};

/**
* | output |
* | --- |
* | "Not to build. Local dev simulates D1, R2, Queues, Durable Objects, crons, and workflows. You need an account when you deploy, and the free tier goes a long way." |
*
* @param {Marketing_Faq_Cloudflare_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_faq_cloudflare_detail = /** @type {((inputs?: Marketing_Faq_Cloudflare_DetailInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Faq_Cloudflare_DetailInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_faq_cloudflare_detail(inputs)
	if (locale === "es") return es_marketing_faq_cloudflare_detail(inputs)
	return fr_marketing_faq_cloudflare_detail(inputs)
});